import { render, staticRenderFns } from "./sql-reference.vue?vue&type=template&id=6678a462"
import script from "./sql-reference.vue?vue&type=script&lang=js"
export * from "./sql-reference.vue?vue&type=script&lang=js"
import style0 from "./sql-reference.vue?vue&type=style&index=0&id=6678a462&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports